"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderMenu = exports.renderMenuItem = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _UIList = _interopRequireDefault(require("../../list/UIList"));

var _SubDropdownMenu = _interopRequireDefault(require("../internal/SubDropdownMenu"));

var _DropdownMenuOption = _interopRequireDefault(require("../internal/DropdownMenuOption"));

var _UIDropdownDivider = _interopRequireDefault(require("../UIDropdownDivider"));

var renderMenuItem = function renderMenuItem(option, index) {
  // case where you just pass in a React element instead of an object (convienience)
  if (_react.default.isValidElement(option)) {
    return _react.default.cloneElement(option, {
      key: index
    });
  } // case of passing in a nested menu
  else if (option.label && option.options) {
      var label = option.label,
          options = option.options,
          rest = (0, _objectWithoutProperties2.default)(option, ["label", "options"]);
      return _react.default.createElement(_SubDropdownMenu.default, (0, _extends2.default)({
        key: index,
        buttonText: label
      }, rest, {
        options: options
      }));
    } // case of passing in an element with options for the menu
    else if (option.label) {
        var _label = option.label,
            _rest = (0, _objectWithoutProperties2.default)(option, ["label"]);

        return _react.default.createElement(_DropdownMenuOption.default, (0, _extends2.default)({
          key: index
        }, _rest), _label);
      } // don't return anything if it isn't valid


  return null;
};

exports.renderMenuItem = renderMenuItem;

var renderMenu = function renderMenu(abstractTree) {
  if (!abstractTree || abstractTree.length === 0) return null;
  return _react.default.createElement(_UIList.default, {
    role: "menu"
  }, abstractTree.map(function (option, index) {
    if (Array.isArray(option)) {
      var items = option.map(function (item, index2) {
        return renderMenuItem(item, index2);
      });

      if (abstractTree.length > index + 1) {
        items.push(_react.default.createElement(_UIDropdownDivider.default, null));
      }

      return items;
    }

    return renderMenuItem(option, index);
  }));
};

exports.renderMenu = renderMenu;